// Copyright (c) 2020-2023 Visual Intelligence LP. All rights reserved.
//
import { injectable } from 'inversify';

import config from './config.json';
import { RepoProvider } from '@shared/models/document-repo';

// Struct to store items from json file.
export interface ConfigType {
  apiURL: string;
  errorTrackingAppID: string;
  autocomplete: {
    itemsCount: number;
  };
  version: string;
  googleMapsKey: string;
  itwinClientId: string;
  itwinClientSecret: string;
  itwinRedirectURL: string;

  syncfusionLic: string;
  twinvierwerToken: string;

  repoQStr2Provider: Array<{regExp: string, provider: string}>, // RegExp to match the redirect-url query string to a provider name.
  repositories: Array<RepoProvider>                             // List of conf params for repositories.

  machineSpecifics: Array<{host: string, iTwinClientId: string}>;
}

// Class to load config values from the config.json file.
@injectable()
export default class Config {
  static diToken = Symbol('config');

  private config: ConfigType;

  initialize() {
    this.set();
  }

  get() {
    return this.config;
  }

  // config.local points to the portal-api service.
  private set() {
    this.config = {
      ...(config[window.location.origin] || config.local),
      ...config.common
    };
  }
}